export enum UserRole{
    Admin,
    User,
    Manager,
    SuperAdmin
}
